package com.kaihuoy.components.common

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun TIcon(name: String, size: CSSNumericValue<*>? = null) {
    I(attrs = {
        classes("ti", "ti-$name")
        if (size != null) style { fontSize(size) }
    }) {}
}
